// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5986f561","977":"c3665c47"}[chunkId] + ".chunk.js";
};